"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "uscio": {
    "6c18946c": [{
      "hkey": "f5c84b6b",
      "slug": "calcinara-caprile",
      "name": "Calcinara-Caprile",
      "primary": false,
      "skipSearch": false
    }],
    "89ef29bb": [{
      "hkey": "f5c84b6b",
      "slug": "calcinara-caprile",
      "name": "Calcinara-Caprile",
      "primary": true,
      "skipSearch": false
    }],
    "calcinara": [{
      "hkey": "f5c84b6b",
      "slug": "calcinara-caprile",
      "name": "Calcinara-Caprile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "caprile": [{
      "hkey": "f5c84b6b",
      "slug": "calcinara-caprile",
      "name": "Calcinara-Caprile",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "uscio"
    }]
  }
};
exports["default"] = _default;